import byStatus from './byStatus';
import byFeatureGroup from './byFeatureGroup';
import byLastLoginDate from './byLastLoginDate';

const namespaced = true;

export const getters = {
  appliedFilters: (state, gttrs) => {
    return Object.keys(state)
      .map(key => {
        const { name } = state[key];
        const value = gttrs[`${key}/humanReadableValue`];

        return { name, value };
      })
      .filter(filter => filter.value);
  },
};

export default {
  namespaced,
  state: {},
  getters,
  modules: {
    byStatus,
    byFeatureGroup,
    byLastLoginDate,
  },
};
